module.exports = __webpack_public_path__ + "static/media/list-tree.e57556f3.svg";